/**
 * Dữ liệu mẫu cho màn Module của cổng tenant (ADR-0096 mục 8) khi chạy `?mock=` hoặc chưa đăng nhập Keycloak thật.
 * Nộp gói thì nằm IN_REVIEW chờ quản trị tổ chức duyệt (ADR-0115); duyệt bản mới thì bản cũ thành DEPRECATED. Cài thì
 * lượt cài qua INSTALLING rồi ACTIVE.
 */
import type { ModulePackageResult, ModuleVersion } from '../modules/quan-ly-module/types';
import type { LuotCai, ModuleDaDuyet } from '../modules/module-to-chuc/types';

function truocDay(gio: number): string {
  return new Date(Date.now() - gio * 3_600_000).toISOString();
}

const DA_DUYET: ModuleDaDuyet[] = [
  {
    module_id: 'mod-demo-sdk', code: 'demo-sdk', name: 'Demo SDK', vendor: 'FoxAI', version: '0.3.0', status: 'PUBLISHED',
    description: 'Module mẫu viết bằng @foxaitechnologyjsc/module-sdk, có màn tổng quan và màn quản lý công việc.',
    permissions: [{ code: 'demo-sdk:tong-quan:read' }, { code: 'demo-sdk:cong-viec:read' }, { code: 'demo-sdk:cong-viec:write' }],
    created_at: truocDay(24),
  },
  {
    module_id: 'mod-crm', code: 'crm', name: 'Quản lý khách hàng', vendor: 'FoxAI', version: '1.0.0', status: 'PUBLISHED',
    description: 'Danh bạ khách hàng, lịch sử liên hệ và cơ hội bán hàng.',
    permissions: [{ code: 'crm:khach-hang:read' }],
    created_at: truocDay(24 * 30),
  },
];

/** Mọi phiên bản module riêng của tổ chức (kể cả của người khác nộp), mới nộp trước: nguồn của hàng chờ duyệt. */
const PHIEN_BAN_TO_CHUC: ModuleVersion[] = [
  {
    version_id: 'ver-bao-gia-1.0.0', module_id: 'mod-bao-gia', code: 'bao-gia', name: 'Báo giá nhanh',
    vendor: 'Tổ chức của tôi', version: '1.0.0', status: 'DEPRECATED', submitted_at: truocDay(24 * 10),
    submitted_by: 'u-003', reviewed_at: truocDay(24 * 9), reviewed_by: 'u-004', review_note: null,
    frontend_entry: null, menus: [],
  },
  {
    version_id: 'ver-bao-gia-1.1.0', module_id: 'mod-bao-gia', code: 'bao-gia', name: 'Báo giá nhanh',
    vendor: 'Tổ chức của tôi', version: '1.1.0', status: 'PUBLISHED', submitted_at: truocDay(24 * 3),
    submitted_by: 'u-003', reviewed_at: truocDay(24 * 2), reviewed_by: 'u-004', review_note: 'Đã soát quyền',
    frontend_entry: null, menus: [],
  },
  {
    version_id: 'ver-bao-gia-1.2.0', module_id: 'mod-bao-gia', code: 'bao-gia', name: 'Báo giá nhanh',
    vendor: 'Tổ chức của tôi', version: '1.2.0', status: 'IN_REVIEW', submitted_at: truocDay(2),
    submitted_by: 'u-003', reviewed_at: null, reviewed_by: null, review_note: null, frontend_entry: null, menus: [],
  },
];

const GOI_CUA_TOI: ModuleVersion[] = [];
const LUOT_CAI = new Map<string, { status: LuotCai['status']; lanHoi: number }>();

export function moduleDaDuyetGia(): ModuleDaDuyet[] {
  return DA_DUYET;
}

export function goiCuaToiGia(): ModuleVersion[] {
  return [...GOI_CUA_TOI];
}

export function choDuyetGia(): ModuleVersion[] {
  return [...PHIEN_BAN_TO_CHUC];
}

export function nopGoiToChucGia(tep: File): ModulePackageResult {
  const code = tep.name.replace(/\.zip$/i, '').replace(/-\d+\.\d+\.\d+$/, '').toLowerCase() || 'module-moi';
  const version = `1.0.${GOI_CUA_TOI.length}`;
  const phienBan: ModuleVersion = {
    version_id: `ver-${code}-${version}`, module_id: `mod-${code}`, code, name: code, vendor: 'Tổ chức của tôi',
    version, status: 'IN_REVIEW', submitted_at: new Date().toISOString(), submitted_by: 'u-004',
    reviewed_at: null, reviewed_by: null, review_note: null, frontend_entry: null, menus: [],
  };
  GOI_CUA_TOI.unshift(phienBan);
  PHIEN_BAN_TO_CHUC.unshift(phienBan);
  return { code, version, status: 'IN_REVIEW' };
}

function timPhienBan(code: string, version: string): ModuleVersion {
  const row = PHIEN_BAN_TO_CHUC.find((v) => v.code === code && v.version === version);
  if (!row) throw new Error(`Không có phiên bản ${code} ${version}`);
  return row;
}

/** Duyệt: bản PUBLISHED trước đó của module thành DEPRECATED, như `ModuleReviewService.duyet`. */
export function duyetToChucGia(code: string, version: string): ModuleVersion {
  const row = timPhienBan(code, version);
  for (const v of PHIEN_BAN_TO_CHUC) {
    if (v.code === code && v.status === 'PUBLISHED') v.status = 'DEPRECATED';
  }
  Object.assign(row, { status: 'PUBLISHED', reviewed_at: new Date().toISOString(), reviewed_by: 'u-004' });
  return { ...row };
}

export function tuChoiToChucGia(code: string, version: string, reason: string): ModuleVersion {
  const row = timPhienBan(code, version);
  Object.assign(row, {
    status: 'REJECTED', reviewed_at: new Date().toISOString(), reviewed_by: 'u-004', review_note: reason,
  });
  return { ...row };
}

export function xoaModuleGia(code: string): void {
  for (let i = PHIEN_BAN_TO_CHUC.length - 1; i >= 0; i -= 1) {
    if (PHIEN_BAN_TO_CHUC[i].code === code) PHIEN_BAN_TO_CHUC.splice(i, 1);
  }
  for (let i = GOI_CUA_TOI.length - 1; i >= 0; i -= 1) {
    if (GOI_CUA_TOI[i].code === code) GOI_CUA_TOI.splice(i, 1);
  }
}

export function caiGia(code: string): LuotCai {
  LUOT_CAI.set(code, { status: 'INSTALLING', lanHoi: 0 });
  return { installation_id: `cai-${code}`, module_id: `mod-${code}`, code, version: '1.0.0', status: 'INSTALLING' };
}

export function goGia(code: string): LuotCai {
  LUOT_CAI.set(code, { status: 'REMOVING', lanHoi: 0 });
  return { installation_id: `cai-${code}`, module_id: `mod-${code}`, code, version: '1.0.0', status: 'REMOVING' };
}

/** Hai lần hỏi đầu còn INSTALLING (REMOVING), sau đó ACTIVE (REMOVED): đủ để soát trạng thái "đang cài/gỡ" trên màn. */
export function luotCaiGia(code: string): LuotCai {
  const luot = LUOT_CAI.get(code) ?? { status: 'ACTIVE' as const, lanHoi: 0 };
  luot.lanHoi += 1;
  if (luot.status === 'INSTALLING' && luot.lanHoi > 2) luot.status = 'ACTIVE';
  if (luot.status === 'REMOVING' && luot.lanHoi > 2) luot.status = 'REMOVED';
  LUOT_CAI.set(code, luot);
  return { installation_id: `cai-${code}`, module_id: `mod-${code}`, code, version: '1.0.0', status: luot.status };
}
